import Cookies from 'js-cookie';

export const BROWSER_IS_WORKS = /WorksMobile/.test(navigator.userAgent);

export const getLanguage = BROWSER_IS_WORKS
  ? getLanguageFromBrowser
  : getLanguageFromCookie;

const supportedLangs = ['en_US', 'ja_JP', 'ko_KR', 'zh_CN', 'zh_TW'];

export function getLanguageFromCookie() {
  const lang = Cookies.get('language') ?? Cookies.get('LC');
  return supportedLangs.includes(lang) ? lang : 'en_US';
}

export function getLanguageFromBrowser() {
  const navLang = (navigator.languages ?? [navigator.language])[0]
    .replace('-', '_')
    .toLowerCase();
  return (
    supportedLangs.find((name) => name.toLowerCase() === navLang) ??
    supportedLangs.find((name) => name.toLowerCase().startsWith(navLang)) ??
    supportedLangs[0]
  );
}

export function getTimezoneFromCookie() {
  return Cookies.get('timezone') ?? Cookies.get('TZ') ?? 'Asia/Seoul';
}

export function getRegionFromCookie() {
  return Cookies.get('WORKS_RE_LOC');
}

export function preventDefault(callback = () => {}) {
  return (event) => {
    event.preventDefault();
    callback(event);
  };
}

export function stopPropagation(callback = () => {}) {
  return (event) => {
    event.stopPropagation();
    callback(event);
  };
}

export { default as A } from './A';
